var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('jet-banner'),_vm._v(" "),_c('main',[_vm._t("default")],2),_vm._v(" "),_c('portal-target',{attrs:{"name":"modal","multiple":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }